export default "__VITE_PUBLIC_ASSET__f72f5875__"